<template>
    <section v-if="hasPermissions(['Census-Vacant-Bed Read', 'Census-Vacant-Bed Write', 'Census-Vacant-Bed Vacant-Bed-Upload'])" class="view">
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <h1 class="view__title title--1">
            {{ title_page }}
        </h1>
        <div class="view__description">
            <p class="view__description__text">
                This is a list of all Patient Beds. To update manually, check off all Vacant beds, then click Update. To upload a file, select Upload File on the Upload Options menu, browse to the file, select the vacant bed file and click open.
            </p>
        </div>

        <div class="bar-container-vacant-beds">
            <input type="date" v-model="form_data.date" v-if="hasPermissions(['Census-Vacant-Bed Read'])">
            <div class="bar-container-vacant-beds__search-bar">
                <div class="input-field my-0"  v-if="hasPermissions(['Census-Vacant-Bed Read'])">
                    <i class="material-icons prefix iconInput">search</i>
                    <input id="icon_prefix" type="text" class="validate inputSearch" placeholder="Search" @input="(e) => debounceInput('search', e.target.value)">
                </div>
            </div>
            <div class="bar-container-vacant-beds__options">
                <select style="width: 20%" class="input-field custom-select mr-2" v-if="hasPermissions(['Census-Vacant-Bed Read'])" v-model="state_beds_filter">
                    <option value="" v-html="'All Beds'"/>
                    <option value="0" v-html="'Occupied Beds'"/>
                    <option value="1" v-html="'Vacant Beds'"/>
                </select>
                <div class="modal__buttons__item w-auto px-3" v-if="hasPermissions(['Census-Vacant-Bed Supervisor-Report']) || hasPermissions(['Census-Vacant-Bed Worksheet-Report'])">
                    <button type="button" style="border-top-right-radius: 0px; border-bottom-right-radius: 0px;" v-html="'Reports'" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"/>
                    <button type="button" class="dropdown-toggle dropdown-toggle-split ml-0" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="border-top-left-radius: 0px; border-bottom-left-radius: 0px; padding-right:0px;">
                        <span class="sr-only"/>
                    </button>
                    <div class="dropdown-menu" :style="'font-size: 14px; padding:0; margin-top: 0px;'">
                        <a class="dropdown-item" v-html="'Supervisor'" @click="confirmReport(true)" v-if="hasPermissions(['Census-Vacant-Bed Supervisor-Report'])"/>
                        <a class="dropdown-item" v-html="'Worksheets'" @click="confirmReport(false)" v-if="hasPermissions(['Census-Vacant-Bed Worksheet-Report'])"/>
                        <a class="dropdown-item" v-html="'Vacant Beds'" @click="bedsReport(10)" v-if="hasPermissions(['Census-Vacant-Bed Vacant-Beds-Report'])"/>
                        <a class="dropdown-item" v-html="'Ocuppied Beds'" @click="bedsReport(11)" v-if="hasPermissions(['Census-Vacant-Bed Ocuppied-Beds-Report'])"/>
                        <a class="dropdown-item" v-html="'All Beds'" @click="bedsReport(12)" v-if="hasPermissions(['Census-Vacant-Bed All-Beds-Report'])"/>
                    </div>
                </div>
            
                <UploadOptions
                :ref="'file_excel'"
                :empty_format_data="empty_format_data"
                :excel_file_headers="excel_file_headers"
                :file_name="'vacant_bed_code_template_file'"
                @data="upload($event)"
                v-if="hasPermissions(['Census-Vacant-Bed Vacant-Bed-Upload'])"
                />

                <UploadOptionsTXT
                :ref="'file_txt'"
                :empty_format_data="empty_format_data"
                :excel_file_headers="excel_file_headers"
                :file_name="'vacant_bed_code_template_file'"
                @data="upload($event, 'txt')"
                v-if="hasPermissions(['Census-Vacant-Bed Vacant-Bed-Upload'])"
                />

                <button
                    class="modal__buttons__item w-auto mr-md-auto ml-sm-2 px-3 ml-md-2 m-0"
                    v-html="`Update <img class='ml-2' width='15px' src='/assets/img/svg/add-w.svg' alt=''/>`"
                    @click="setBedStatuses(true)"
                    v-if="hasPermissions(['Census-Vacant-Bed Write'])"
                />
        </div>
        </div>
        <div class="row  bar__container" style="margin-top:6px;" v-if="hasPermissions(['Census-Vacant-Bed Read'])">
            <div class="col-md-2 py-0 mb-3 mb-md-0">
                <div class="my-4 mb-md-0 text-center text-md-left vacantbed__list__description">
                    <p class="view__section__text">
                        {{ `Vacant beds: ${count_from} out of ${count_until}` }}
                        <span class="d-block">
                            Occupancy: {{parseInt(ocupancy)}}%
                        </span>
                    </p>
                </div>
            </div>
            
        </div>
        
        <div class="tab-content" v-show="hasPermissions(['Census-Vacant-Bed Read'])">
            <div class="tab-pane fade active show" id="listation">
                <div class="row mb-0 no-gutters">
                    <div class="col-lg-12">
                        <v-card>
                            <DinamicTableInfiniteLoader
                                :name="'AdvancedSearch'"
                                :selectable_columns="true"
                                :array_options_table="{}"
                                :headers="table_headers"
                                :items="bed_codes"
                                :pagination="pagination"
                                :search="search"
                                :checkable="true"
                                :size="30"
                                :detail_text="'sadaasd'"
                                @fetchMainList="fetchMainList($event)"
                                @paginateMoreRecords="paginateMoreRecords($event)"
                                ref="main_table"
                            />
                        </v-card>
                    </div>
                </div>
            </div>
        </div>
        <SupervisorReportModal 
            :title="'Confirmation modal'"
            :breadcrumb="breadcrumb"
            :rest_api="rest_api"
            :supervisor_report="supervisor_report"
            @supervisorReport="supervisorReport($event)"
            @worksheetsReport="worksheetsReport($event)"
        />

        <WaitingModal/>
        <UploadSummary
            :breadcrumb="breadcrumb"
            :summary="summary"
            :excel_file_headers="excel_file_headers"
            :excel_data="excel_data"
            :file_name="'vacant_bed_code_failed_template_file'"
        />
        <HelperModal :helps="helps"/>
    </section>
    <div v-else>
        <UnauthorizedComponent :breadcrumb="breadcrumb"/>
    </div>
</template>

<script>

import FormResources from './form_resources'
import SupervisorReportModal from './SupervisorReportModal'
import UploadOptions from '@/components/UploadOptions'
import HelperModal    from    '@/components/HelperModal'
import UploadOptionsTXT from '@/components/UploadOptionsTXT'
import axios from 'axios'
import Breadcrumb from '@/components/BreadcrumbComponent/Breadcrumb'
import WaitingModal from '@/components/WaitingModal'
import DinamicTableInfiniteLoader from    '@/components/DinamicTableInfiniteLoader'
import Resources from './resources'
import UnauthorizedComponent from   '@/components/UnauthorizedComponent'
import moment from 'moment'
import 'vuetify/dist/vuetify.min.css'
import { Notyf } from 'notyf'
import 'notyf/notyf.min.css' // for React and Vue
const notyf = new Notyf({
    duration: 8000,
});
import _ from 'lodash'
import UploadSummary from '@/components/UploadSummary';

export default {

    name: "VacantBed",

    components: {
        Breadcrumb,
        WaitingModal,
        DinamicTableInfiniteLoader,
        UploadOptions,
        UploadOptionsTXT,
        UnauthorizedComponent,
        SupervisorReportModal,
        HelperModal,
        UploadSummary
    },

    data() {
        return {
            notyf,
            axios,
            user:       this.get_user(),
            child_href: '/census-vacant-beds/',
            title_page: 'Vacant beds list',
            rest_api: `vacant_dates`,
            rest_api_pagination: 'vacant_dates_pagination',
            ext_rest_api: `bed_statuses`,
            table_headers: Resources.table_headers,
            breadcrumb: Resources.breadcrumb,
            form_data: FormResources.form_data,
            count_from: 0,
            count_until: 0,
            ocupancy: 0,
            single_select: false,
            table_selection: [],
            search: '',
            global_index: '',
            single_object: {},
            vacants: [],
            bed_codes: [],
            array_options: {},
            excel_file_headers: Resources.excel_file_headers,
            empty_format_data: Resources.empty_format_data,
            excel_data: [],
            watch_counter: 0,
            state_beds_filter: '',
            supervisor_report: true,
            helps:                  Resources.helps,
            pagination: null,
            summary: [],
        }
    },

    watch: {

        form_data: {
            handler()
            {
                this.resetList()
            },
            deep: true
        },

        async 'state_beds_filter'()
        {
            this.resetList()
        }

    },

    methods: 
    {
        debounceInput: _.debounce(function (key, value) {
            this.form_data[key] = value;
        }, 800),


        async fetchMainList(params) 
        {
            this.bed_codes = [];
            await this.showLoader()
            await this.apiRequest({...params, ...this.form_data, state_beds_filter: this.state_beds_filter}, true)
        },

        async paginateMoreRecords(params)
        {
            if(this.pagination !== null && this.bed_codes.length >= this.pagination?.total)
            {
                return;
            }
            
            await this.showLoader()

            console.log({...params, ...this.form_data});
            await this.apiRequest({...params, ...this.form_data, state_beds_filter: this.state_beds_filter})
        },

        async loadMoreRecords(data, reset_list)
        {
            if(reset_list)
            {
                this.bed_codes = []
            }

            if(data.pagination.data.length)
            {
                data.pagination.data.forEach((item) => {
                    item.checked = this.$refs.main_table.select_all == true ? true : item.checked
                    this.bed_codes.push(item)
                })
            }
            this.pagination = data.pagination

            this.countable()

            await this.hideLoader(data.pagination.data)
        },

        resetList()
        {
            this.$refs.main_table.params['page'] = 1;
            this.fetchMainList(this.$refs.main_table.params)
        },

        isSelectAll()
        {
            return this.$refs.main_table.select_all
        },

        async setBedStatuses()
        {
            const selection =  {...this.$refs.main_table.returnSelection(), params: {...this.$refs.main_table.params, ...this.form_data, state_beds_filter: this.state_beds_filter}}

            selection.checked_items = selection.checked_items.map(item => item.id)
            selection.unchecked_items = selection.unchecked_items.map(item => item.id)

            this.loader(true)

            let response = await this.post(this.ext_rest_api, selection)

            if(response.status)
            {  
                notyf.success('Success')
                this.api_request()
            }

            this.loader()

        },

        confirmReport(param)
        {
            this.supervisor_report = param
            window.$('#static-supervisor-modal').modal('show')
        },

        async supervisorReport(event)
        {
            const form_data = {
                standard_report_id: 5,
                headers: Resources.supervisor_report_table_headers,
                totals: Resources.supervisor_report_totals,
                format: event.format_report,
                params: {
                    timestamp:  moment().format('MM/DD/YYYY HH:mm:ss'),
                    date: this.form_data.date
                }
            }

            form_data.headers[3].show = event.show_discharge_capability
            
            window.$('#static-supervisor-modal').modal('hide')

            this.loader(true)

            const response = await this.post('search_standard_reports', form_data)

            if(response.status)
            {
                this.downloadFile(response)
            }
            else
            {
                window.$('#static-supervisor-modal').modal('show')
                this.error_handling(response)
            }

            this.loader()
        },

        async worksheetsReport(event)
        {
            const form_data = {
                standard_report_id: 6,
                show_discharge_capability: event.show_discharge_capability,
                format: event.format_report
            }
            
            // form_data.headers[3].show = event.show_discharge_capability
            
            window.$('#static-supervisor-modal').modal('hide')

            this.loader(true)

            const response = await this.post('search_standard_reports', form_data)

            if(response.status)
            {
                this.downloadFile(response)
            }
            else
            {
                window.$('#static-supervisor-modal').modal('show')
                this.error_handling(response)
            }

            this.loader()
        },

        async bedsReport(event)
        {
            const form_data = {
                headers: Resources.beds_report_table_headers,
                standard_report_id: event,
                format: event.format_report,
                params: {
                    timestamp:  moment().format('MM/DD/YYYY HH:mm:ss')
                }
            }

            this.loader(true)

            const response = await this.post('search_standard_reports', form_data)

            if(response.status)
            {
                this.downloadFile(response)
            }
            else
            {
                this.error_handling(response)
            }

            this.loader()
        },

        async upload(data, type)
        {
            if(!data.length)
            {
                notyf.error('No data available')
                return false
            }

            this.excel_data = []

            if(type === 'txt')
            {
                data.forEach(code => {
                    this.excel_data.push({'Code': code})
                });
            }
            else
            {
                this.excel_data = data
            }

            this.loader(true)
            const response = await this.post(`${this.ext_rest_api}/massive`, { beds: this.excel_data,  params: {...this.$refs.main_table.params, ...this.form_data, state_beds_filter: this.state_beds_filter}, timestamp: this.getCurrentDateTime() })
            this.loader()

            if(response.status)
            {
                if(response.data.is_queue)
                {
                    notyf.success('Given you are uploading many records, you will get notified when the upload process is finished.')
                    return;
                }
                this.excel_file_headers = Resources.excel_file_headers
                notyf.success('Success!')
                this.summary = response.data.summary
                window.$('#upload-summary').modal('show')

                this.resetList()
            }
            else
            {
                this.error_handling(response)
            }

            this.$refs.file_excel.clear_data()
            
        },

        countable()
        {
            this.count_from =  this.pagination.vacant_beds_count
            this.count_until = this.pagination.total
            this.count_from_occupancy = this.count_until - this.count_from
    
            let cant_x = this.count_from_occupancy
            let semifinal = cant_x * 100
            let final = semifinal/this.count_until
            this.ocupancy = final
        },

        fill_data(data)
        {
            // this.bed_codes = data.beds
            if(this.form_data.date)
            {
                // this.getBedStatuses(this.form_data.date)
            }
            else
            {
                this.form_data.date = data.current_date

            }
            
            this.count_until = this.bed_codes.length
        },

        async showLoader()
        {
            this.$refs.main_table.showLoader()
        },

        async hideLoader(data)
        {
            this.$refs.main_table.hideLoader(data)
        }

    },

    async mounted()
    {
        if(this.hasPermissions(['Census-Vacant-Bed Read', 'Census-Vacant-Bed Write', 'Census-Vacant-Bed Vacant-Bed-Upload']))
        {
            await this.api_request()
        }
     
    },
};
</script>